import { render, staticRenderFns } from "./container-tab.vue?vue&type=template&id=488a442a&scoped=true"
import script from "./container-tab.vue?vue&type=script&lang=js"
export * from "./container-tab.vue?vue&type=script&lang=js"
import style0 from "./container-tab.vue?vue&type=style&index=0&id=488a442a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488a442a",
  null
  
)

export default component.exports